(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/marketplace/account-selector/assets/javascripts/constants.js') >= 0) return;  svs.modules.push('/components/marketplace/account-selector/assets/javascripts/constants.js');
"use strict";


setGlobal('svs.components.marketplace.accountSelector.constants', {
  USER_PLACEHOLDER: 'user'
});

 })(window);